
import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { Field, useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';

import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import _ from 'lodash';
export const HseForm = ({ handleChange, handleBlur, values, errors, touched, initialized }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      {
        <>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="hseSchoolName">
              <BSForm.Label>School Name</BSForm.Label>
              <BSForm.Control
                type="text"
                name={`hseSchoolName`}
                value={values.hseSchoolName}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'hseSchoolName', initialized)}`}
              />
              <span className="errorMessage">{getErrorMessage(errors, touched, 'hseSchoolName', initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="courseType">
              <BSForm.Label>Start MM/YYYY</BSForm.Label>
              <ReactDatePicker
                name={'hseStartDate'}
                selected={values.hseStartDate ? new Date(values.hseStartDate) : null}
                onChange={(val) => {
                  setFieldValue('hseStartDate', val, true);
                }}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'hseStartDate', initialized)}`}
                dateFormat="MM/yyyy"
                maxDate={new Date()}
                showMonthYearPicker
              />
              <span className="errorMessage">{getErrorMessage(errors, touched, 'hseStartDate', initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>End MM/YYYY</BSForm.Label>
              <ReactDatePicker
                name={'hseEndDate'}
                selected={values.hseEndDate ? new Date(values.hseEndDate) : null}
                onChange={(val) => {
                  setFieldValue('hseEndDate', val, true);
                }}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'hseEndDate', initialized)}`}
                dateFormat="MM/yyyy"
                maxDate={new Date()}
                showMonthYearPicker
              />
              <span className="errorMessage">{getErrorMessage(errors, touched, 'hseEndDate', initialized)}</span>
            </BSForm.Group>
          </Row>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>CGPA/Percentage</BSForm.Label>
              <BSForm.Control
                type="text"
                name="hseCGPA"
                value={values.hseCGPA}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${getErrorClass(errors, touched, 'hseCGPA', initialized)}`}
              ></BSForm.Control>
              <span className="errorMessage">{getErrorMessage(errors, touched, 'hseCGPA', initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank">
              <BSForm.Label>Rank</BSForm.Label>
              <BSForm.Control
                type="number"
                name="hseRank"
                value={values.hseRank}
                onChange={handleChange}
                onBlur={handleBlur}
                min={0}
                className={`form-control ${getErrorClass(errors, touched, 'hseRank', initialized)}`}
              ></BSForm.Control>
              <span className="errorMessage">{getErrorMessage(errors, touched, 'hseRank', initialized)}</span>
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="hseRank"></BSForm.Group>
          </Row>
          <Row className="mb-3">
            <BSForm.Group as={Col} controlId="hasHseBackLog">
              <BSForm.Label>Do you have any Backpapers,Drop Year?</BSForm.Label>
              <SigniteToggle
                id={'hasHseBackLog'}
                dataYes={'Yes'}
                dataNo={'No'}
                fieldInput={{
                  onChange: handleChange,
                  value: values.hasHseBackLog,
                }}
              />
            </BSForm.Group>
            <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
            <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
          </Row>
          {values.hasHseBackLog && (
            <Row className="mb-3">
              <BSForm.Group as={Col} controlId="courseType">
                <BSForm.Label>Start MM/YYYY</BSForm.Label>
                <ReactDatePicker
                  name={'hseBacklogStartDate'}
                  selected={values.hseBacklogStartDate ? new Date(values.hseBacklogStartDate) : null}
                  onChange={(val) => {
                    setFieldValue('hseBacklogStartDate', val, true);
                  }}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(errors, touched, 'hseBacklogStartDate', initialized)}`}
                  dateFormat="MM/yyyy"
                  maxDate={new Date()}
                  showMonthYearPicker
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'hseBacklogStartDate', initialized)}
                </span>
              </BSForm.Group>
              <BSForm.Group as={Col} controlId="blank">
                <BSForm.Label>End MM/YYYY</BSForm.Label>
                <ReactDatePicker
                  name={'hseBacklogEndDate'}
                  selected={values.hseBacklogEndDate ? new Date(values.hseBacklogEndDate) : null}
                  onChange={(val) => {
                    setFieldValue('hseBacklogEndDate', val, true);
                  }}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(errors, touched, 'hseBacklogEndDate', initialized)}`}
                  dateFormat="MM/yyyy"
                  maxDate={new Date()}
                  showMonthYearPicker
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'hseBacklogEndDate', initialized)}
                </span>
              </BSForm.Group>
              <BSForm.Group as={Col} controlId="hseBacklogReason">
                <BSForm.Label>Reason *</BSForm.Label>
                <BSForm.Control
                  name={`hseBacklogReason`}
                  value={values.hseBacklogReason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${getErrorClass(errors, touched, 'hseBacklogReason', initialized)}`}
                />
                <span className="errorMessage">
                  {getErrorMessage(errors, touched, 'hseBacklogReason', initialized)}
                </span>
              </BSForm.Group>
            </Row>
          )}
          <hr style={{ marginTop: 32, marginBottom: 32 }} />
        </>
      }
    </div>
  );
};
